export default function routerLocations(state = {}, action) {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return {
        prevRoute: state.currentRoute,
        currentRoute: action.payload,
      };
    default:
      return state;
  }
}

